import React from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { FaRegTrashCan } from "react-icons/fa6";

const DeleteAddress = ({ addressId, handleDeleteAddress }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div>
      <FaRegTrashCan
        className="cursor-pointer"
        onClick={() => {
          onOpen();
        }}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <div className="mt-10 mb-3">
              <h1 className="text-center font-semibold text-xl">
                Are you sure want to delete this address?
              </h1>

              <div className="flex justify-end gap-4 mt-16">
                <button
                  className="bg-[#c7c7c7] hover:bg-[#d4d4d4] w-28 text-black py-1 px-4 border border-[#c2c2c2] rounded"
                  onClick={() => {
                    onClose();
                  }}
                >
                  Cancel
                </button>

                <button
                  className="bg-[#f52e2e] hover:bg-[#f54040] w-28 text-white py-1 px-4 border border-[#f52e2e] rounded"
                  onClick={() => {
                    onClose();
                    handleDeleteAddress(addressId);
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default DeleteAddress;
